import { render, staticRenderFns } from "./sixChip.vue?vue&type=template&id=2fd70cff&scoped=true&"
import script from "./sixChip.vue?vue&type=script&lang=js&"
export * from "./sixChip.vue?vue&type=script&lang=js&"
import style0 from "./sixChip.vue?vue&type=style&index=0&id=2fd70cff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd70cff",
  null
  
)

export default component.exports